const udidEndpoint = 'https://h.seznam.cz/udid';
export function fetchUdid(markerCookie) {
    return new Promise(async (resolve, reject) => {
        let payload = '';
        try {
            payload = JSON.stringify({
                // random hex string of 32 characters
                // eslint-disable-next-line camelcase
                request_id: crypto
                    .getRandomValues(new Uint8Array(16))
                    .reduce((acc, val) => acc + val.toString(16).padStart(2, '0'), ''),
                // old udid
                ...(markerCookie && { udid: markerCookie }),
            });
        }
        catch (e) {
            reject(e);
            return;
        }
        if (typeof fetch !== 'undefined') {
            const response = await fetch(udidEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: payload,
                credentials: 'include',
            });
            if (!response.ok) {
                reject(new Error('Network response was not ok'));
                return;
            }
            response.json().then((res) => (!!res.udid ? resolve(res.udid) : reject('Empty udid identifier')), reject);
        }
        else {
            // @ts-ignore it is test
            const xhr = new XMLHttpRequest();
            xhr.open('POST', udidEndpoint, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.withCredentials = true;
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            const response = JSON.parse(xhr.responseText);
                            if (response.udid) {
                                resolve(response.udid);
                            }
                            else {
                                reject(new Error('Empty udid identifier'));
                            }
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                    else {
                        reject(new Error('Network response was not ok'));
                    }
                }
            };
            xhr.onerror = function () {
                reject(new Error('Network request failed'));
            };
            xhr.send(payload);
        }
    });
}
